export function truncate(input: string, num: number) {
  if (input?.length > num) {
    return input.substring(0, num) + '...';
  }
  return input;
}
